import axios from '@/utils/api'

const actions = {
  /**
   * Processa arquivo ZIP com plantas PDF usando key do FileManager
   */
  async processarZip (context, {fileKey, inserirAssinatura}) {
    return axios({
      method: 'POST',
      url: 'v1/processamentoPlanta/processar',
      data: { fileKey, inserirAssinatura },
      timeout: 900000, // 15 minutos para processar ZIP de até 500MB
      loader: true,
      error: true
    })
  },

  /**
   * Lista registros com paginação e filtros
   */
  async listarRegistros (context, params) {
    return axios({
      method: 'GET',
      url: 'v1/processamentoPlanta',
      params,
      loader: false
    })
  },

  /**
   * Busca registro por ID
   */
  async buscarPorId (context, id) {
    return axios({
      method: 'GET',
      url: `v1/processamentoPlanta/${id}`,
      loader: false
    })
  },

  /**
   * Vincula memorial a um processo
   */
  async vincularProcesso (context, { id, numeroProcesso }) {
    return axios({
      method: 'PUT',
      url: `v1/processamentoPlanta/${id}/vincular`,
      data: {
        numeroProcesso
      },
      loader: true,
      error: true
    })
  },

  /**
   * Executa vinculação automática
   */
  async executarVinculacaoAutomatica (context) {
    return axios({
      method: 'POST',
      url: 'v1/processamentoPlanta/vincular-automatico',
      loader: true,
      error: true
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/processamentoPlanta.js